import countries from 'i18n-iso-countries';

export default function formatCountryName(code) {
  return countries.getName(code, 'es', {
    select: 'official',
  });
}
